export const images = [
    {
        url: '/textures/animals/chameleon.jpg',
        name: 'Chameleon',
        index: 4
    },
    {
        url: '/textures/animals/leopard.jpg',
        name: 'Leopard',
        index: 3
    },
    {
        url: '/textures/animals/lion.jpg',
        name: 'Lion',
        index: 2
    },
    {
        url: '/textures/animals/lioness.jpg',
        name: 'Lioness',
        index: 1
    },
    {
        url: '/textures/animals/lynx.jpg',
        name: 'Lynx',
        index: 12
    },
    {
        url: '/textures/animals/nyala.jpg',
        name: 'Nyala',
        index: 11
    },
    {
        url: '/textures/animals/parrot.jpg',
        name: 'Parrot',
        index: 10
    },
    {
        url: '/textures/animals/red-panda.jpg',
        name: 'Red panda',
        index: 9
    },
    {
        url: '/textures/animals/squirrel.jpg',
        name: 'Squirrel',
        index: 8
    },
    {
        url: '/textures/animals/tiger.jpg',
        name: 'Tiger',
        index: 7
    },
    {
        url: '/textures/animals/wolf.jpg',
        name: 'Wolf',
        index: 6
    },
    {
        url: '/textures/animals/zebra.jpg',
        name: 'Zebra',
        index: 5
    },

]